module.exports = __webpack_public_path__ + "static/media/t20-wc-2.fa0cc7a0.jpg";